export function shouldRefetchGeometryOnReturnToMap<T extends string | number>(
  isInitialMount: boolean,
  previousTab: T,
  currentTab: T,
  mapTab: T,
  tableTab: T
): boolean {
  if (isInitialMount) {
    return false;
  }
  return previousTab === tableTab && currentTab === mapTab;
}
